module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    ref: "mymessage",
    staticClass: "myaddresseditlist"
  }, [_c('div', {
    staticClass: "myaddresseditlist-content"
  }, [_c('div', {
    staticClass: "rating-wrapper"
  }, [_c('ul', [_vm._l((_vm.myaddresseditlist), function(item, index) {
    return _c('li', {
      staticClass: "rating-item",
      on: {
        "click": function($event) {
          _vm.selectFood(index, item, $event)
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('h1', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t('name')) + ":" + _vm._s(item.CustomerName) + "  ")]), _vm._v(" "), _c('div', {
      staticClass: "star-wrapper"
    }, [_c('span', {
      staticClass: "delivery"
    }, [_vm._v(_vm._s(item.Street) + " , " + _vm._s(item.City))])]), _vm._v(" "), _c('div', {
      staticClass: "star-wrapper"
    }, [_c('span', {
      staticClass: "delivery"
    }, [_vm._v(_vm._s(item.Province) + " , " + _vm._s(item.Zip))])]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("\n                 " + _vm._s(_vm.$t('phone')) + " : " + _vm._s(item.LinkmanPhone) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "defaultaddress"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.state.defaultaddress),
        expression: "state.defaultaddress"
      }],
      staticClass: "checkbtn",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": index,
        "checked": _vm._q(_vm.state.defaultaddress, index)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.state, "defaultaddress", index)
        }
      }
    })])])])
  }), _vm._v(" "), _c('li', {
    staticClass: "rating-item",
    on: {
      "click": function($event) {
        _vm.addAddress($event)
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "add-address"
  }, [_c('i', {
    staticClass: "icon-add_circle",
    staticStyle: {
      "color": "#00b43c"
    }
  })])])])], 2)])]), _vm._v(" "), _c('myaddressedit', {
    ref: "myaddressedit"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b7aa812","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myaddress/myaddress.vue
// module id = 480
// module chunks = 1